import { root } from "@/shared/store";
import Vue from "vue";
import Vuex from "vuex";
import VueCompositionApi from "@vue/composition-api";
import { SocialThemeWidgetState } from "./models/social-theme-widget-state";
import SocialThemeWidget from "./SocialThemeWidget.vue";
import mutations from "../SocialThemeWidget/store/mutations";
import getters from "../SocialThemeWidget/store/getters";

Vue.use(VueCompositionApi);
Vue.config.productionTip = false;

let widgetEls = document.querySelectorAll('widget-social-theme');
if (widgetEls.length) {
    widgetEls.forEach(el => {
        let store = new Vuex.Store({
            state: new SocialThemeWidgetState,
            mutations: mutations,
            getters: getters,
            modules: {
                root
            }
        })
        new Vue({
            el: el,
            store,
            render(h: any) {
                let themes = this.$el.attributes.getNamedItem('themes');
                let moreButtonLabel = this.$el.attributes.getNamedItem('more-button-label');
                let moreButtonUrl = this.$el.attributes.getNamedItem('more-button-url');
                return h(SocialThemeWidget, {
                    props: {
                        themes: themes ? JSON.parse(themes.value) : null,
                        moreButtonLabel: moreButtonLabel ? moreButtonLabel.value : null,
                        moreButtonUrl: moreButtonUrl ? moreButtonUrl.value : null,
                    }
                })
            }
        });
    });
}
